export const lightTheme = {
  bgColor: "#FDFDFD",
  textColor: "#31302E",
  mainPageBg: "#F4F4F4",
  borderColor: "1px solid #EAEAEA",
  phaseCardShadowColor: '#4babfa',
  hoverColor: "rgba(0,0,0,0.12)",
  disabledTextColor: '#CACACA',
  errorColor: "#ff1476",
  successColor: "#3ba55d",
};

export const darkTheme = {
  bgColor: "#0B0B0E",
  mainPageBg: "#1F1F1F",
  textColor: "#CCCCCC",
  borderColor: "1px solid #2C2D33",
  phaseCardShadowColor: '#161616',
  hoverColor: "rgba(255,255,255,0.12)",
  disabledTextColor: '#626262',
  errorColor: "#ff8da1",
  successColor: "#3ba55d",
};

export const theme = {
  lightTheme,
  darkTheme,
};
